(function () {
  function handler(event) {
    const btn = event.target.closest('.SizeChart__btn');
    if (!btn) return;

    const chartEl = btn.closest('[data-size-chart]');
    if (!chartEl) return;

    const btns = chartEl.querySelectorAll('.SizeChart__btn');
    const firstWrap = chartEl.querySelector('.SizeChart__image--first');
    const secondWrap = chartEl.querySelector('.SizeChart__image--second');
    if (!firstWrap || !secondWrap) return;

    btns.forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');

    const unit = btn.dataset.unit;
    if (unit === 'first') {
      firstWrap.classList.add('is-active');
      secondWrap.classList.remove('is-active');
    } else {
      firstWrap.classList.remove('is-active');
      secondWrap.classList.add('is-active');
    }
  }

  document.addEventListener('click', handler, true);
  document.addEventListener('touchend', handler, true);
})();
